const day = 86400000;
const trialPeriod = day * 7;
const year = day * 365;
const basePayDate = 1577876400000;

export { trialPeriod, year, basePayDate, day };
